import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const ProductPageSkeleton = () => {
  return (
    <div className="main-content-container product-page">
      <div className="skeleton-product-page">
        {/* Colonna sinistra - Immagine */}
        <div className="skeleton-product-image-column">
          <div className="skeleton-product-image-card skeleton-loader"></div>
        </div>

        {/* Colonna destra - Dettagli prodotto */}
        <div className="skeleton-product-details-column">
          {/* Titolo */}
          <div className="skeleton-product-title-large skeleton-loader"></div>
          
          {/* Brand */}
          <div className="skeleton-product-brand-medium skeleton-loader"></div>
          
          {/* Venditore principale */}
          <div className="skeleton-product-vendor skeleton-loader"></div>
          
          {/* Prezzo e disponibilità */}
          <div className="skeleton-product-pricing skeleton-loader"></div>
          
          {/* Sezione varianti */}
          <div className="skeleton-product-variant-section">
            <div className="skeleton-product-variant-title skeleton-loader"></div>
            <div className="skeleton-product-variant-options">
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="skeleton-product-variant-option skeleton-loader"></div>
              ))}
            </div>
          </div>
          
          {/* Sezione varianti colori */}
          <div className="skeleton-product-variant-section">
            <div className="skeleton-product-variant-title skeleton-loader"></div>
            <div className="skeleton-product-variant-options">
              {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className="skeleton-product-variant-option color skeleton-loader"></div>
              ))}
            </div>
          </div>
          
          {/* EAN */}
          <div className="skeleton-loader" style={{ height: '16px', width: '30%' }}></div>
          
          {/* Informazioni di spedizione */}
          <div className="skeleton-product-shipping-section skeleton-loader"></div>
          
          {/* Descrizione */}
          <div className="skeleton-product-description skeleton-loader"></div>
        </div>
      </div>
    </div>
  );
};

export default ProductPageSkeleton; 